//* //
const REACT_APP_MARKETS_URL = './notices.json';
/*/
const REACT_APP_MARKETS_URL = '/wp-json/awd_market_buddy/v1/options/notices';
// */

interface AwdScriptObject {
    nonce: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AwdScriptObject: AwdScriptObject = (window as any).AwdScriptObject || { nonce: "d8cb8f4715" };


export { REACT_APP_MARKETS_URL };
export { AwdScriptObject };